export const MOBILE_LEAD_FORM_2_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    status: true,
  },

  MOBILE_LEAD_FORM_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "Admission Closed on 02 Feb",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter title text (e.g., Admission Closed on 02 Feb)",
      required: false,
      defaultValue: "Admission Closed on 02 Feb",
    },
    {
      fieldName: "title_color",
      label: "Title Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_start_color",
      label: "Background Gradient Start Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter gradient start color (e.g., #02A7B6)",
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "gradient_end_color",
      label: "Background Gradient End Color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter gradient end color (e.g., #342B7C)",
      defaultValue: "#342B7C",
    },
    {
      fieldName: "gradient_angle",
      label: "Background Gradient Angle",
      value: "180deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 180deg)",
      defaultValue: "180deg",
    },
    {
      fieldName: "enable_timer",
      label: "Enable Timer",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable or disable countdown timer",
      defaultValue: true,
    },
    {
      fieldName: "timer_end_date",
      label: "Timer End Date",
      value: "",
      valueType: "string",
      filedType: "DATE",
      placeholder: "Select end date",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "timer_end_time",
      label: "Timer End Time",
      value: "23:59:59",
      valueType: "string",
      filedType: "TIME",
      placeholder: "Select end time",
      required: false,
      defaultValue: "23:59:59",
    },
    {
      fieldName: "timer_number_color",
      label: "Timer Number Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter timer number color (e.g., #222222)",
      defaultValue: "#222222",
    },
    {
      fieldName: "timer_text_color",
      label: "Timer Text Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter timer text color (e.g., #222222)",
      defaultValue: "#222222",
    },
    {
      fieldName: "timer_background_color",
      label: "Timer Background Color",
      value: "rgba(255, 255, 255, 0.8)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter timer background color",
      defaultValue: "rgba(255, 255, 255, 0.8)",
    },
    {
      fieldName: "cta_text",
      label: "CTA Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA button text (e.g., Apply Now)",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_button_text_color",
      label: "CTA Button Text Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button text color (e.g., #222222)",
      defaultValue: "#222222",
    },
    {
      fieldName: "cta_button_color",
      label: "CTA Button Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Mobile Lead Form Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable or disable mobile lead form",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [],
};
